import { MAIN_URL } from "./ServiceConstants";
import axios from "axios";

async function upsertClinic(Action, Id, formDataObj) {
  return axios.post(MAIN_URL + "/OrthoMagic/SetPortalClinic", {
    dataobject: { Action, Id, ...formDataObj },
  });
}

function getClinicsList(postData) {
  return axios.post(MAIN_URL + "/OrthoMagic/SetPortalClinic", {
    dataobject: { Action: "S" },
  });
}

function deleteClinic(clinicId) {
  return axios.post(MAIN_URL + "/OrthoMagic/SetPortalClinic", {
    dataobject: { Action: "D", Id: clinicId },
  });
}

function getNotifications() {
  return axios.post(MAIN_URL + "/OrthoMagic/getNotifications", {})
}

function setCommentsReaad(patientId) {
  return axios.post(MAIN_URL + "/OrthoMagic/SetCommentsReaad", {
    dataobject: {PatientId : patientId}
  })
}

function getImageSets() {
  return axios.post(MAIN_URL + "/OrthoMagic/GetAllPatientImgSet", {})
}

const DoctorService = { upsertClinic, getClinicsList, deleteClinic, getNotifications, setCommentsReaad, getImageSets };

export default DoctorService;
